import { ThemeColors } from '@evrekadev/evreka-ui-components'
import { Flex, Typography } from 'components'
import React from 'react'
import { Alert02Icon } from '../icons'

export const DataError: React.FC = () => {
  return (
    <Flex
      style={{
        padding: '4rem',
      }}
      directionColumn="zero"
      gap={0.5}
      middle="zero"
      center="zero"
    >
      <Alert02Icon height={64} width={64} color={ThemeColors.grey600} />
      <Typography fontSize="text_lg" fontWeight="semibold" color="grey600">
        Something Went Wrong
      </Typography>
      <Typography fontSize="text_sm" fontWeight="medium" color="grey600">
        Please try again later.
      </Typography>
    </Flex>
  )
}
